export default __webpack_public_path__ + "static/media/einsterns_schwester.2da32983.jpg";